import { render, staticRenderFns } from "./PagesHeaderWidget.vue?vue&type=template&id=3569573c&"
import script from "./PagesHeaderWidget.vue?vue&type=script&lang=js&"
export * from "./PagesHeaderWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports